module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documentType":"Document Type","client":"Client Document","payment":"Payment Document"},"al":{"documentType":"Tipi i Dokumentit","client":"Dokument Klienti","payment":"Dokument Pagese"}}')
  delete Component.options._Ctor
}
